import { render, staticRenderFns } from "./MultiTagDialog.vue?vue&type=template&id=7a51ab2a&scoped=true&"
import script from "./MultiTagDialog.vue?vue&type=script&lang=ts&"
export * from "./MultiTagDialog.vue?vue&type=script&lang=ts&"
import style0 from "./MultiTagDialog.vue?vue&type=style&index=0&id=7a51ab2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a51ab2a",
  null
  
)

export default component.exports